import { required } from "@vuelidate/validators";
const okurumteklif = {
  data() {
    return {
      okurumteklifData: {
        Birimid: null,
        Tarih: null,
        Tutar: null,
        Modulids: [],
        Teklifiveren: null,
        Durum: null,
        Aciklama: null,
        Dosyayolu: null,
      },
      FormDataType: {
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Kurum", ComboData: {}, ComboDataArray: [], Multiple: false },
        Tarih: { FieldName: "Tarih", Field: "date", FieldTitle: "Teklif Tarihi" },
        Tutar: { FieldName: "Tutar", Field: "input", FieldTitle: "Teklif Tutarı" },
        Modulids: { FieldName: "Modulids", Field: "combobox", FieldTitle: "Modüller", ComboData: {}, ComboDataArray: [], Multiple: true },
        Teklifiveren: { FieldName: "Teklifiveren", Field: "input", FieldTitle: "Teklifi Veren" },
        Durum: { FieldName: "Durum", Field: "combobox", FieldTitle: "Teklif Durumu", ComboData: {}, ComboDataArray: [], Multiple: false },
        Aciklama: { FieldName: "Aciklama", Field: "textarea", FieldTitle: "Not" },
      }

    }
  },
  validations: {
    FormData: {
      Birimid: { required },
      Tarih: { required },
      Tutar: {},
      Modulids: {},
      Teklifiveren: {},
      Durum: {},
      Aciklama: {},
      Dosyayolu: {},
    }
  },

  created() {

    this.ActionsFilterGet({ Service: "obirim/gettree", FullData: true, Filter: "" }).then((res) => {
      this.FormDataType.Birimid.ComboDataArray = res.Data
    });

    this.ActionsFilterGet({ Service: "okeyvalues", FullData: true, Filter: "&Asc=Kod&Tip=8" }).then((res) => {
      this.FormDataType.Modulids.ComboDataArray = res.Data.map(item => ({
        id: item.Id,
        label: item.Value
      }));
    });

    this.FormDataType.Durum.ComboDataArray = [
      { id: true, label: "Olumlu" },
      { id: false, label: "Olumsuz" },
    ];

  }
}
export default okurumteklif
